import * as React from 'react'
import { ReactElement } from 'react'
import FileForm, { FileFormType } from '../../components/Form/File/FileForm'
import { FileAction, FileMutationDto, IOverviewItemDto, ScaffoldDto } from '../../config/fileConfig'
import Loading from '../../components/Loading'
import useEntity from '../../hooks/useEntity'
import useUser from '../../hooks/useUser'
import useAxios from '../../hooks/useAxios'
import { Billable } from '../../config/registration/timeConfig'
import useUnits from '../../hooks/useUnits'
import { useDispatch, useSelector } from 'react-redux'
import { Store } from '../../reducers'
import { DataPromise } from '../../context/AxiosContext'
import { IFileListSettings } from '../../components/List/File/FileList'
import useModules from '../../hooks/module/useModules'
import { ModulesConstants } from '../../components/Form/File/ModulePivotItem'
import { useSettings } from '../../hooks/useSettings'
import { parseFileSettingsToParams } from './FileOverview'
import { ModuleType } from '../../context/GlobalContext'

export default function AddFile(): ReactElement {
    const axios = useAxios()
    const dispatch = useDispatch()

    const currentUser = useUser()
    const { activeUnits } = useUnits()
    const modules = useModules()
    const settings = useSettings()
    const [scaffold] = useEntity<ScaffoldDto>(() => ({ url: '/file/scaffold', method: 'POST' }), false)
    const { settings: fileSettings } = useSelector<Store, DataPromise<IOverviewItemDto[], IFileListSettings>>(
        state => state.files.overview,
    )

    if (!scaffold.loaded) {
        return <Loading />
    }

    const initialValues: FileMutationDto = {
        name: '',
        ownerId: currentUser.id,
        language: settings?.fileScaffold?.language || 'nl',
        currency: settings?.fileScaffold?.currency || 'EUR',
        billable: settings?.fileScaffold?.billable || Billable.Billable,
        unit: modules.has(ModuleType.Accounting) && activeUnits.length === 1 ? activeUnits[0].key : undefined,
        ...scaffold.data,
    }

    const fileModules = modules.modules
        ?.filter(module => module.fileModule)
        ?.filter(module => module.defaultActiveForFile)
        .map(
            module =>
                ModulesConstants.get(module.type)?.defaultValue(initialValues, settings) ?? {
                    type: module.type,
                },
        )

    if (fileModules && fileModules.length > 0) {
        initialValues.modules = fileModules
    }

    modules?.modules
        ?.filter(module => !module.fileModule)
        .forEach(module => ModulesConstants.get(module.type)?.onAfterChecked(initialValues, settings))

    return (
        <FileForm
            formType={FileFormType.Add}
            formikProps={{ initialValues }}
            onSubmit={(file: FileMutationDto) =>
                axios.post<string>('/file', file).then(response => {
                    dispatch({
                        type: FileAction.GetOverview,
                        payload: axios.get('/file', { params: parseFileSettingsToParams(fileSettings) }),
                    })
                    return response
                })
            }
        />
    )
}
